import { Global, LineOverSchedule } from '../../model';
import { NewValuesTooltipScheduleTaskable } from './tooltip_schedule_taskable';
export class NewValuesTooltipSchedule {
  static set(newVal = {}, schedule: LineOverSchedule){
    let taskData = schedule.taskData();
    let taskable = NewValuesTooltipScheduleTaskable.set({}, schedule);
    newVal['planner_tooltip_detail'] = {
      responsible_name:    taskData.responsible_text,
      location_name:       taskable.location_name,
      day_memo:            schedule.memoValue(),
      memo:                taskData.memo,
      phaseData:           schedule.phaseData()
    }
  }
}
